import stbAPIGateway from '../../../../services/stbAPIGateway';

// eslint-disable-next-line import/prefer-default-export
export const fetchClientGeneral = async ({ rootGetters, commit }, clientSid) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = await stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getClientGeneral(clientSid);
  if (response.data) {
    commit('setClientGeneral', response.data);
  }
  return response;
};
